export default "__VITE_ASSET__jqd2vNCm__"